export default "__VITE_ASSET__BJjkU4pQ__"